export { default } from './PartnerWithUs';
